import { Controller, useFormContext } from 'react-hook-form';
import { Field, Input } from '@billda/design-system';
import type { FC } from 'react';

/**
 * Molecule: Currency input with formatting
 * Following form-architecture.md Controller pattern
 */
export const PriceInputField: FC = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      name="price"
      control={control}
      render={({ field }) => (
        <Field
          label="Price *"
          error={errors.price?.message?.toString()}
          hint={
            errors.price?.message
              ? undefined
              : 'Adjust price for this specific plot'
          }
        >
          <Input
            {...field}
            type="number"
            invalid={!!errors.price}
            startAdornment={<span className="text-content-secondary">£</span>}
            onChange={e => {
              const value = parseFloat(e.target.value);
              field.onChange(isNaN(value) ? 0 : value);
            }}
          />
        </Field>
      )}
    />
  );
};
